import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CheckBoxOptions, DropdownOptions, EnglishArabicDTO, FilterItem, FilterType, ForceDirection, InputType, MultiLingualTextBoxOptions, PagingOptions, TextAreaOptions, TextBoxOptions } from 'bbsf-controls';
import { ClipboardService } from 'ngx-clipboard';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { TemplateDTO } from '../../shared/models/NotificationsModels/TemplateDTO';
import { TemplateService } from '../../shared/Services/TemplateService.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bbsf-utilities';

@Component({
  selector: 'lib-templates',
  templateUrl: './templates.component.html'
})
export class TemplatesComponent implements OnInit {

  ApiUrl = "/api/admin/Templates/"
  CategoryOptions: DropdownOptions;
  TypeOptions: DropdownOptions;
  searchTextBox: TextBoxOptions;
  SelectedTemplateList = [];
  CategoryList = [];
  TypeList = [];
  OrganizationList = [];
  LanguageModeList = [];
  MasterLayoutList = [];
  filterForm = new FormGroup({});
  TemplateForm = new FormGroup({});
  showFilter: boolean = false;
  TemplatePagingResult: any[] = [];
  TemplatePaging: PagingOptions;
  CategoryFilter: FilterItem;
  TypeFilter: FilterItem;
  TextInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  ProductionMode: boolean = false;
  @ViewChild('TemplatePagingViewElement', { static: false }) input: ElementRef;

  //Add Model Controls
  AddTemplateForm = new FormGroup({});
  MultiLingualName:MultiLingualTextBoxOptions
  SysName: TextBoxOptions;
  DescriptionInEnglish: TextAreaOptions;
  DescriptionInArabic: TextAreaOptions;
  Organization: DropdownOptions;
  LanguageMode: DropdownOptions;
  Category: DropdownOptions;
  MasterLayout: DropdownOptions;
  IsEmail: CheckBoxOptions;
  IsSms: CheckBoxOptions;
  EnableIntensiveLogging: CheckBoxOptions;
  @ViewChild('CloseTemplateModal', { static: false }) CloseTemplateModal: ElementRef;
  
  //Edit Model Controls
  EditTemplateForm = new FormGroup({});
  TemplateId:number
  EditMultiLingualName:MultiLingualTextBoxOptions
  EditSysName: TextBoxOptions;
  EditDescriptionInEnglish: TextAreaOptions;
  EditDescriptionInArabic: TextAreaOptions;
  EditOrganization: DropdownOptions;
  EditLanguageMode: DropdownOptions;
  EditCategory: DropdownOptions;
  EditMasterLayout: DropdownOptions;
  EditIsEmail: CheckBoxOptions;
  EditIsSms: CheckBoxOptions;
  EditEnableIntensiveLogging: CheckBoxOptions;
  @ViewChild('CloseEditTemplateModal', { static: false }) CloseEditTemplateModal: ElementRef;

  //delete  Model Controls
  deletedTemplateId: number = 0
  @ViewChild('CloseDeleteTemplateModal', { static: false }) CloseDeleteTemplateModal: ElementRef;

  //GenerateCode  Model Controls 
  GenerateCodeForm = new FormGroup({});
  GenerateCodeTextArea: TextAreaOptions;
  ValueToCopy: string = "";
  language:string="";
  ShowPageContent:boolean=false;
  constructor(private authService:AuthService,private pageInfoService:PageInfoService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService,private _clipboardService: ClipboardService, private templateService: TemplateService, private modalService: NgbModal) {
  }
  async ngOnInit() {
    this.ShowPageContent=true;
    PageInfoService.PageTitle= this.utilityService.getResourceValue("Templates")
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}

    ];
    
    
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language = await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.LoadDropdownLists();
  }

 
  ReinitializeTemplatePaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }
  UpdateTemplatePaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }
  setTemplateListResult(result) {
    this.TemplatePagingResult = result
    this.ShowPageContent=true;
    this.utilityService.stopBlockUI()
  }
  resetFilters() {
    this.TemplateForm.controls["Category"].setValue([]);
    this.TemplateForm.controls["Type"].setValue([]);
    this.TemplateForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();

  }
  LoadDropdownLists() {
    this.templateService.Loaddropdowns().subscribe((result) => {
      let DropdownLists = result as any
      this.OrganizationList = DropdownLists.organization
      this.CategoryList = DropdownLists.lookUpItemsCategory
      this.TypeList = DropdownLists.types
      this.MasterLayoutList = DropdownLists.emailHeaderAndFooterTemplate
      this.LanguageModeList = DropdownLists.lookUpItemsEmailTemplate

      this.CategoryOptions = new DropdownOptions();
      this.CategoryOptions.Name = "Category"
      this.CategoryOptions.LabelKey = "Category"
      this.CategoryOptions.DataSource = this.CategoryList
      this.CategoryOptions.SingleSelection = false;
      this.CategoryOptions.AllowSearchFilter = true;
      this.CategoryOptions.Placeholder = "";

      this.TypeOptions = new DropdownOptions();
      this.TypeOptions.Name = "Type"
      this.TypeOptions.LabelKey = "Type"
      this.TypeOptions.DataSource = this.TypeList
      this.TypeOptions.SingleSelection = true;
      this.TypeOptions.AllowSearchFilter = true;
      this.TypeOptions.Placeholder = "";

      // TextBox inti
      this.searchTextBox = new TextBoxOptions();
      this.searchTextBox.Name = "searchTextBox"
      this.searchTextBox.Type = InputType.Text
      this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName")
      this.searchTextBox.HideLabel = true

      this.CategoryFilter = new FilterItem();
      this.CategoryFilter.FormControlName = "Category"
      this.CategoryFilter.ActionParameterName = "CategoryItemID"
      this.CategoryFilter.IsFormControl = true
      this.CategoryFilter.FilterType = FilterType.DropdownList

      this.TypeFilter = new FilterItem();
      this.TypeFilter.FormControlName = "Type"
      this.TypeFilter.ActionParameterName = "type"
      this.TypeFilter.IsFormControl = true
      this.TypeFilter.FilterType = FilterType.DropdownList

      this.TextInputFilter = new FilterItem();
      this.TextInputFilter.FormControlName = "searchTextBox"
      this.TextInputFilter.ActionParameterName = "searchText"
      this.TextInputFilter.IsFormControl = true
      this.TextInputFilter.FilterType = FilterType.TextBox

      this.TemplatePaging = new PagingOptions();
      this.TemplatePaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetTemplatesByFilter';
      this.TemplatePaging.OnKeyPressFiltersControlNames = ["searchTextBox"]
      this.TemplatePaging.DropdownFiltersControlNames = ["Category", "Type"];
      this.TemplatePaging.Filters = [this.CategoryFilter, this.TypeFilter, this.TextInputFilter]
      this.TemplatePaging.ValidationToken = this.authService.authorizationHeaderValue()
      this.IsFilterLoaded = true;
    
    })
  }

  showAddTemplateModal(AddTemplateModal) {
    this.utilityService.startBlockUI();
    this.AddTemplateForm = new FormGroup({})

    this.MultiLingualName = new MultiLingualTextBoxOptions();
    this.MultiLingualName.Name = "Name";
    this.MultiLingualName.ArabicLabelKey = "NameInArabic";
    this.MultiLingualName.EnglishLabelKey = "NameInEnglish";
    this.MultiLingualName.IsRequired = true;
    this.MultiLingualName.Value = null;

    this.SysName = new TextBoxOptions();
    this.SysName.Name = "SysName";
    this.SysName.LabelKey = "SysName";
    this.SysName.Type = InputType.Text;
    this.SysName.Value = null;

    this.DescriptionInEnglish = new TextAreaOptions();
    this.DescriptionInEnglish.Name = "DescriptionInEnglish";
    this.DescriptionInEnglish.LabelValue = "DescriptionInEnglish";
    this.DescriptionInEnglish.Value = null;

    this.DescriptionInArabic = new TextAreaOptions();
    this.DescriptionInArabic.Name = "DescriptionInArabic";
    this.DescriptionInArabic.LabelKey = "DescriptionInArabic";
    this.DescriptionInArabic.Value = null;

    this.Organization = new DropdownOptions();
    this.Organization.Name = "Organization"
    this.Organization.LabelKey = "Organization"
    this.Organization.DataSource = this.OrganizationList
    this.Organization.SingleSelection = true;
    this.Organization.AllowSearchFilter = true;
    this.Organization.Placeholder = "";
    this.Organization.IsRequired = true;

    this.LanguageMode = new DropdownOptions();
    this.LanguageMode.Name = "LanguageMode"
    this.LanguageMode.LabelKey = "LanguageMode"
    this.LanguageMode.DataSource = this.LanguageModeList
    this.LanguageMode.SingleSelection = true;
    this.LanguageMode.AllowSearchFilter = true;
    this.LanguageMode.Placeholder = "";
    this.LanguageMode.IsRequired = true;

    this.MasterLayout = new DropdownOptions();
    this.MasterLayout.Name = "MasterLayout"
    this.MasterLayout.LabelKey = "MasterLayout"
    this.MasterLayout.DataSource = this.MasterLayoutList
    this.MasterLayout.SingleSelection = true;
    this.MasterLayout.AllowSearchFilter = true;
    this.MasterLayout.Placeholder = "";
    this.MasterLayout.IsRequired = true;

    this.Category = new DropdownOptions();
    this.Category.Name = "Category"
    this.Category.LabelKey = "Category"
    this.Category.DataSource = this.CategoryList
    this.Category.SingleSelection = true;
    this.Category.AllowSearchFilter = true;
    this.Category.Placeholder = "";
    this.Category.IsRequired = true;

    this.IsEmail = new CheckBoxOptions();
    this.IsEmail.Name = "IsEmail"
    this.IsEmail.LabelKey = "Email"

    this.IsSms = new CheckBoxOptions();
    this.IsSms.Name = "IsSms"
    this.IsSms.LabelKey = "SMS"
  
    this.EnableIntensiveLogging = new CheckBoxOptions();
    this.EnableIntensiveLogging.Name = "EnableIntensiveLogging"
    this.EnableIntensiveLogging.LabelKey = "EnableIntensiveLogging"
    this.modalService.open(AddTemplateModal);
    this.utilityService.stopBlockUI();

  }
  addTemplate() {
    if (this.AddTemplateForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.AddTemplateForm.value;
      let TemplateModel = new TemplateDTO();
      TemplateModel.Name.Arabic = ResultModel.Name.ArabicValue;
      TemplateModel.Name.English = ResultModel.Name.EnglishValue;
      TemplateModel.SysName = ResultModel.SysName
      TemplateModel.Description.English = ResultModel.DescriptionInEnglish
      TemplateModel.Description.Arabic = ResultModel.DescriptionInArabic
      TemplateModel.OrganizationID = Number(ResultModel.Organization)
      TemplateModel.CategoryItemID = Number(ResultModel.Category)
      TemplateModel.LanguageModeItemID = Number(ResultModel.LanguageMode)
      TemplateModel.EmailHeaderAndFooterTemplateID = Number(ResultModel.MasterLayout)
      TemplateModel.IsEmail = ResultModel.IsEmail!=null?ResultModel.IsEmail:false;
      TemplateModel.IsSms = ResultModel.IsSms!=null?ResultModel.IsSms:false;
      TemplateModel.EnableIntensiveLogging = ResultModel.EnableIntensiveLogging!=null?ResultModel.EnableIntensiveLogging:false;
      this.templateService.AddEmailTemplate(TemplateModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.ReinitializePaging();
      }, (error) => {
        
      })
    }
  }
  showEditTemplateModal(Template: any, EditTemplateModal) {

    this.utilityService.startBlockUI();
    this.EditTemplateForm = new FormGroup({})

    this.TemplateId = Template.id

    let Name=new EnglishArabicDTO();
    Name.Arabic=Template.name.arabic;
    Name.English=Template.name.english;

    this.EditMultiLingualName = new MultiLingualTextBoxOptions();
    this.EditMultiLingualName.Name = "Name";
    this.EditMultiLingualName.ArabicLabelKey = "NameInArabic";
    this.EditMultiLingualName.EnglishLabelKey = "NameInEnglish";
    this.EditMultiLingualName.IsRequired = true;
    this.EditMultiLingualName.Value = Name;

   
    this.EditSysName = new TextBoxOptions();
    this.EditSysName.Name = "EditSysName";
    this.EditSysName.LabelKey = "SysName";
    this.EditSysName.Type = InputType.Text;
    this.EditSysName.Value = Template.sysName;


    this.EditDescriptionInEnglish = new TextAreaOptions();
    this.EditDescriptionInEnglish.Name = "EditDescriptionInEnglish";
    this.EditDescriptionInEnglish.LabelKey = "DescriptionInEnglish";
    this.EditDescriptionInEnglish.Value = Template.description.english;


    this.EditDescriptionInArabic = new TextAreaOptions();
    this.EditDescriptionInArabic.Name = "EditDescriptionInArabic";
    this.EditDescriptionInArabic.LabelKey = "DescriptionInArabic";
    this.EditDescriptionInArabic.Value = Template.description.arabic;
    this.EditDescriptionInArabic.ForceDirection = ForceDirection.Arabic;

    this.EditOrganization = new DropdownOptions();
    this.EditOrganization.Name = "EditOrganization"
    this.EditOrganization.LabelKey = "Organization"
    this.EditOrganization.DataSource = this.OrganizationList
    this.EditOrganization.SingleSelection = true;
    this.EditOrganization.AllowSearchFilter = true;
    this.EditOrganization.Placeholder = "";
    this.EditOrganization.IsRequired = true;
    this.EditOrganization.SelectedItems = this.OrganizationList.filter((item) => { return parseInt(item.key) == Template.organizationID; }).map((item) => item.key)[0];;


    this.EditLanguageMode = new DropdownOptions();
    this.EditLanguageMode.Name = "EditLanguageMode"
    this.EditLanguageMode.LabelKey = "LanguageMode"
    this.EditLanguageMode.DataSource = this.LanguageModeList
    this.EditLanguageMode.SingleSelection = true;
    this.EditLanguageMode.AllowSearchFilter = true;
    this.EditLanguageMode.Placeholder = "";
    this.EditLanguageMode.IsRequired = true;
    this.EditLanguageMode.SelectedItems = this.LanguageModeList.filter((item) => { return parseInt(item.key) == Template.languageModeItemID; }).map((item) => item.key)[0];;


    this.EditMasterLayout = new DropdownOptions();
    this.EditMasterLayout.Name = "EditMasterLayout"
    this.EditMasterLayout.LabelKey = "MasterLayout"
    this.EditMasterLayout.DataSource = this.MasterLayoutList
    this.EditMasterLayout.SingleSelection = true;
    this.EditMasterLayout.AllowSearchFilter = true;
    this.EditMasterLayout.Placeholder = "";
    this.EditMasterLayout.IsRequired = true;
    this.EditMasterLayout.SelectedItems = this.MasterLayoutList.filter((item) => { return parseInt(item.key) == Template.emailHeaderAndFooterTemplateID; }).map((item) => item.key)[0];;


    this.EditCategory = new DropdownOptions();
    this.EditCategory.Name = "EditCategory"
    this.EditCategory.LabelKey = "Category"
    this.EditCategory.DataSource = this.CategoryList
    this.EditCategory.SingleSelection = true;
    this.EditCategory.AllowSearchFilter = true;
    this.EditCategory.Placeholder = "";
    this.EditCategory.IsRequired = true;
    this.EditCategory.SelectedItems = this.CategoryList.filter((item) => { return parseInt(item.key) == Template.categoryItemID; }).map((item) => item.key)[0];;


    this.EditIsEmail = new CheckBoxOptions();
    this.EditIsEmail.Name = "EditIsEmail"
    this.EditIsEmail.LabelKey = "Email"
    this.EditIsEmail.Value = Template.isEmail


    this.EditIsSms = new CheckBoxOptions();
    this.EditIsSms.Name = "EditIsSms"
    this.EditIsSms.LabelKey = "SMS"
    this.EditIsSms.Value = Template.isSms


    this.EditEnableIntensiveLogging = new CheckBoxOptions();
    this.EditEnableIntensiveLogging.Name = "EditEnableIntensiveLogging"
    this.EditEnableIntensiveLogging.LabelKey = "EnableIntensiveLogging"
    this.EditEnableIntensiveLogging.Value = Template.enableIntensiveLogging
    this.modalService.open(EditTemplateModal);
    this.utilityService.stopBlockUI();


  }
  editTemplate() {
    if (this.EditTemplateForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.EditTemplateForm.value;
      let TemplateModel = new TemplateDTO();
      TemplateModel.ID = Number(this.TemplateId);
      TemplateModel.Name.Arabic = ResultModel.Name.ArabicValue;
      TemplateModel.Name.English = ResultModel.Name.EnglishValue;
      TemplateModel.SysName = ResultModel.EditSysName
      TemplateModel.Description.English = ResultModel.EditDescriptionInEnglish
      TemplateModel.Description.Arabic = ResultModel.EditDescriptionInArabic
      TemplateModel.OrganizationID = Number(ResultModel.EditOrganization)
      TemplateModel.CategoryItemID = Number(ResultModel.EditCategory)
      TemplateModel.LanguageModeItemID = Number(ResultModel.EditLanguageMode)
      TemplateModel.EmailHeaderAndFooterTemplateID = Number(ResultModel.EditMasterLayout)
      TemplateModel.IsEmail = ResultModel.EditIsEmail
      TemplateModel.IsSms = ResultModel.EditIsSms
      TemplateModel.EnableIntensiveLogging = ResultModel.EditEnableIntensiveLogging

      this.templateService.EditEmailTemplate(TemplateModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.UpdatePaging();
      }, (error) => {

      })

    }
  }
  showDeleteEmailTemplateModal(template: any, deleteTemplateModal) {
    this.deletedTemplateId = template.id
    this.utilityService.startBlockUI();
    this.modalService.open(deleteTemplateModal);
    this.utilityService.stopBlockUI();

  }
  deleteEmailTemplate() {
    this.templateService.DeleteTemplate(this.deletedTemplateId).subscribe((result) => {
      this.deletedTemplateId = 0;
      this.modalService.dismissAll();
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {
     
    })

  }
  copyInputMessage() {
    this._clipboardService.copy(this.ValueToCopy.toString());
  }
  showGenerateCodeAllModal(GenerateCodeModal) {
    this.templateService.GenerateCodeAll().subscribe((result) => {
      var Value = result as any
      this.GenerateCodeTextArea = new TextAreaOptions();
      this.GenerateCodeTextArea.Name = "GenerateCodeTextArea";
      this.GenerateCodeTextArea.Value = Value.val.toString();
      this.ValueToCopy = Value.val.toString();
      this.GenerateCodeTextArea.IsDisabled = true;
      this.GenerateCodeTextArea.HideLabel = true;
      this.GenerateCodeTextArea.Rows = 20;
      this.GenerateCodeTextArea.Cols = 20;
      this.GenerateCodeTextArea.MaxLength = 1000000;
      this.modalService.open(GenerateCodeModal);

    }, (error) => {
    
    })
  }
  showGenerateAllUpdateCodeModal(GenerateCodeModal) {
    this.templateService.GenerateAllUpdateCode().subscribe((result) => {
      var Value = result as any
      this.GenerateCodeTextArea = new TextAreaOptions();
      this.GenerateCodeTextArea.Name = "GenerateCodeTextArea";
      this.GenerateCodeTextArea.Value = Value.val.toString();
      this.ValueToCopy = Value.val.toString();
      this.GenerateCodeTextArea.IsDisabled = true;
      this.GenerateCodeTextArea.HideLabel = true;
      this.GenerateCodeTextArea.Rows = 20;
      this.GenerateCodeTextArea.Cols = 20;
      this.GenerateCodeTextArea.MaxLength = 1000000;
      this.modalService.open(GenerateCodeModal);
      
    }, (error) => {
    
    })
  }
  showGeneratSysNameModal(GenerateCodeModal) {
    this.templateService.GenerateSysNames().subscribe((result) => {
      var Value = result as any
      this.GenerateCodeTextArea = new TextAreaOptions();
      this.GenerateCodeTextArea.Name = "GenerateCodeTextArea";
      this.GenerateCodeTextArea.Value = Value.val.toString();
      this.ValueToCopy = Value.val.toString();
      this.GenerateCodeTextArea.IsDisabled = true;
      this.GenerateCodeTextArea.HideLabel = true;
      this.GenerateCodeTextArea.Rows = 20;
      this.GenerateCodeTextArea.Cols = 20;
      this.GenerateCodeTextArea.MaxLength = 1000000;
      this.modalService.open(GenerateCodeModal);
    }, (error) => {
    
    })
  }
 
  showGenerateCodeByIdModal(template: any, GenerateCodeModal) {
    this.templateService.GenerateCodeById(template.id).subscribe((result) => {
      var Value = result as any
      this.GenerateCodeTextArea = new TextAreaOptions();
      this.GenerateCodeTextArea.Name = "GenerateCodeTextArea";
      this.GenerateCodeTextArea.Value = Value.val.toString();
      this.ValueToCopy = Value.val.toString();
      this.GenerateCodeTextArea.IsDisabled = true;
      this.GenerateCodeTextArea.HideLabel = true;
      this.GenerateCodeTextArea.Rows = 20;
      this.GenerateCodeTextArea.Cols = 20;
      this.GenerateCodeTextArea.MaxLength = 1000000;
      this.modalService.open(GenerateCodeModal);
      
    }, (error) => {
     
    })
  }
  showGenerateUpdateCodeByIdModal(template: any, GenerateCodeModal) {
    this.templateService.GenerateUpdateCodeById(template.id).subscribe((result) => {
      var Value = result as any
      this.GenerateCodeTextArea = new TextAreaOptions();
      this.GenerateCodeTextArea.Name = "GenerateCodeTextArea";
      this.GenerateCodeTextArea.Value = Value.val.toString();
      this.ValueToCopy = Value.val.toString();
      this.GenerateCodeTextArea.IsDisabled = true;
      this.GenerateCodeTextArea.HideLabel = true;
      this.GenerateCodeTextArea.Rows = 20;
      this.GenerateCodeTextArea.Cols = 20;
      this.GenerateCodeTextArea.MaxLength = 1000000;
      this.modalService.open(GenerateCodeModal);
    }, (error) => {
      
    })
  }




}
